<template>
  <section class="paykumo-panel" aria-live="polite">
    <div class="paykumo-panel__header">
      <div>
        <span class="paykumo-panel__badge">Paykumo</span>
        <h3>โอนเงินเข้าบัญชีด้านล่าง</h3>
        <p>ระบบจะตรวจสอบและเติมเครดิตให้อัตโนมัติ</p>
      </div>
      <strong>{{ formattedAmount }} บาท</strong>
    </div>

    <div class="paykumo-panel__account">
      <div class="paykumo-panel__row">
        <span>ธนาคาร</span>
        <strong>{{ transaction.receiver_bank || '-' }}</strong>
      </div>
      <div v-if="transaction.receiver_bank_branch" class="paykumo-panel__row">
        <span>สาขา</span>
        <strong>{{ transaction.receiver_bank_branch }}</strong>
      </div>
      <div class="paykumo-panel__row paykumo-panel__row--account">
        <span>เลขบัญชี</span>
        <strong>{{ transaction.receiver_account }}</strong>
        <button type="button" @click="copy(transaction.receiver_account)">คัดลอก</button>
      </div>
      <div class="paykumo-panel__row">
        <span>ชื่อบัญชี</span>
        <strong>{{ transaction.receiver_name || '-' }}</strong>
      </div>
    </div>

    <div class="paykumo-panel__status" role="status">
      <i class="fas fa-spinner" :class="{ 'fa-spin': checking }" />
      <div>
        <h4>{{ checking ? 'กำลังตรวจสอบรายการฝาก' : 'รอรับยอดโอน' }}</h4>
        <p>กรุณาโอนยอดให้ตรงตามจำนวน และอย่าใช้บัญชีนี้กับรายการอื่น</p>
      </div>
    </div>

    <div class="paykumo-panel__notice">
      <i class="fas fa-shield-alt" />
      <span>หลังโอนสำเร็จให้รอหน้านี้ ระบบจะติดตามสถานะและแจ้งทันทีเมื่อเติมเครดิตแล้ว</span>
    </div>

    <button type="button" class="paykumo-panel__cancel" @click="$emit('cancel')">
      ยกเลิกรายการและเปลี่ยนยอดฝาก
    </button>
  </section>
</template>

<script>
export default {
  name: 'PaykumoDepositPanel',
  props: {
    transaction: { type: Object, default: () => ({}) },
    amount: { type: Number, default: 0 },
    checking: { type: Boolean, default: false }
  },
  computed: {
    formattedAmount () {
      return Number(this.amount || 0).toLocaleString('th-TH')
    }
  },
  methods: {
    async copy (value) {
      try {
        await navigator.clipboard.writeText(String(value || ''))
        if (this.$swal) this.$swal({ icon: 'success', title: 'คัดลอกเลขบัญชีแล้ว', timer: 1000, showConfirmButton: false })
      } catch (error) {}
    }
  }
}
</script>

<style scoped>
.paykumo-panel { margin: 16px 15px 22px; padding: 16px; border-radius: 16px; background: linear-gradient(180deg, #0f172a, #172554); color: #fff; font-family: 'Kanit', sans-serif; box-shadow: 0 12px 30px rgba(0, 0, 0, .28); }
.paykumo-panel__header { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; margin-bottom: 14px; }
.paykumo-panel__header h3 { margin: 7px 0 2px; color: #fff; font-size: 19px; }
.paykumo-panel__header p { margin: 0; color: #cbd5e1; font-size: 13px; }
.paykumo-panel__header > strong { white-space: nowrap; color: #93c5fd; font-size: 18px; }
.paykumo-panel__badge { display: inline-flex; padding: 3px 9px; border-radius: 999px; background: #2563eb; color: #fff; font-size: 12px; font-weight: 700; }
.paykumo-panel__account { overflow: hidden; margin-bottom: 12px; border: 1px solid #334155; border-radius: 12px; background: rgba(15, 23, 42, .7); }
.paykumo-panel__row { display: grid; grid-template-columns: 82px 1fr auto; align-items: center; gap: 10px; padding: 11px 13px; border-bottom: 1px solid #334155; }
.paykumo-panel__row:last-child { border-bottom: 0; }
.paykumo-panel__row span { color: #94a3b8; font-size: 12px; }
.paykumo-panel__row strong { overflow-wrap: anywhere; color: #fff; font-size: 15px; }
.paykumo-panel__row--account strong { color: #fef08a; font-size: 20px; letter-spacing: .4px; }
.paykumo-panel__row button { padding: 6px 10px; border: 0; border-radius: 8px; background: #2563eb; color: #fff; font-size: 12px; }
.paykumo-panel__status { display: flex; align-items: center; gap: 14px; padding: 15px; border: 1px solid #334155; border-radius: 12px; background: rgba(30, 41, 59, .72); }
.paykumo-panel__status > i { color: #60a5fa; font-size: 26px; }
.paykumo-panel__status h4 { margin: 0 0 4px; color: #fff; font-size: 16px; }
.paykumo-panel__status p { margin: 0; color: #cbd5e1; font-size: 13px; line-height: 1.45; }
.paykumo-panel__notice { display: flex; align-items: flex-start; gap: 9px; margin-top: 12px; padding: 11px 12px; border: 1px solid rgba(250, 204, 21, .45); border-radius: 10px; background: rgba(250, 204, 21, .1); color: #fef3c7; font-size: 13px; line-height: 1.45; }
.paykumo-panel__cancel { display: block; width: 100%; margin-top: 12px; padding: 12px 14px; border: 0; border-radius: 10px; background: #fee2e2; color: #b91c1c; font-size: 14px; font-weight: 600; }
@media (max-width: 991.98px) {
  .paykumo-panel { position: fixed; inset: 0; z-index: 1070; width: 100vw; height: 100vh; height: 100dvh; margin: 0; padding: max(12px, env(safe-area-inset-top)) max(12px, env(safe-area-inset-right)) max(12px, env(safe-area-inset-bottom)) max(12px, env(safe-area-inset-left)); overflow-y: auto; border-radius: 0; }
  .paykumo-panel__header { margin-top: 28px; }
  .paykumo-panel__row { grid-template-columns: 72px 1fr auto; }
}
</style>
